import { PASSOS } from '@/features/landing/conteudo';

/**
 * Quatro passos do primeiro uso. Existe para responder à pergunta que trava o
 * cadastro — "o que eu preciso ter em mãos para começar?" — antes que o
 * visitante tenha que descobrir isso já dentro do formulário.
 */
export function SecaoComoFunciona() {
  return (
    <section id="como-funciona" className="scroll-mt-20 border-b border-border bg-muted/30 py-20">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <div className="max-w-2xl">
          <p className="text-sm font-semibold uppercase tracking-wider text-accent">Como funciona</p>
          <h2 className="mt-3 text-3xl font-bold tracking-tight text-foreground sm:text-4xl">
            Do primeiro cadastro ao acompanhamento contínuo
          </h2>
        </div>

        <ol className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {PASSOS.map((passo) => (
            <li key={passo.numero} className="relative rounded-xl border border-border bg-card p-6">
              <span className="bg-gradient-nohra bg-clip-text text-3xl font-extrabold text-transparent">
                {passo.numero}
              </span>
              <h3 className="mt-3 font-semibold text-card-foreground">{passo.titulo}</h3>
              <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
                {passo.descricao}
              </p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
